const checkBoxDefaultStyle = theme => ({
  margin: 0,
  alignItems: 'baseline',
  '&.MuiFormControlLabel-root': {
    marginBottom: `${theme.tokens.ComponentCheckboxLabelMargin}`,
    '&:hover .MuiCheckbox-root:not(.Mui-checked, .Mui-disabled)': {
      backgroundColor: `${theme.tokens.ComponentCheckboxDefaultHoverBg}`
    },
    '.MuiCheckbox-root:not(.Mui-checked) svg': {
      width: '10px',
      height: '16px'
    },
    '.Mui-focusVisible': {
      borderStyle: 'solid',
      borderColor: theme.tokens.ComponentCheckboxFocusColor,
      borderWidth: '1px',
      boxShadow: theme.tokens.ComponentCheckboxBoxShadow
    }
  },
  '.MuiFormControlLabel-label': {
    fontSize: `${theme.tokens.ComponentCheckboxLabelFontSize}`,
    fontWeight: 400,
    lineHeight: '20px',
    fontFamily: `${theme.tokens.ComponentCheckboxLabelFontFamily}`,
    cursor: 'pointer',
    color: `${theme.tokens.ComponentCheckboxLabelColor}`
  },
  '.MuiCheckbox-root': {
    backgroundColor: `${theme.tokens.ComponentCheckboxDefaultBg}`,
    height: '20px',
    width: '20px',
    cursor: 'pointer',
    borderRadius: '4px',
    padding: '4px',
    color: `${theme.tokens.ComponentCheckboxDefaultColor}`,
    marginRight: '8px',
    border: `1px solid ${theme.tokens.ComponentCheckboxDefaultBorder}`,
    top: '3px',
    '&:hover': {
      backgroundColor: `${theme.tokens.ComponentCheckboxDefaultHoverBg}`
    },
    '&.Mui-checked': {
      backgroundColor: `${theme.tokens.ComponentCheckboxCheckedBg}`,
      borderRadius: '4px',
      height: '20px',
      width: '20px',
      marginRight: '8px',
      strokeWidth: '2px',
      color: `${theme.tokens.ComponentCheckboxCheckedColor}`,
      borderColor: `${theme.tokens.ComponentCheckboxCheckedBg}`
    },
    '&.MuiCheckbox-indeterminate': {
      svg: {
        strokeWidth: '2px'
      }
    },
    '&.Mui-disabled': {
      color: `${theme.tokens.ComponentCheckboxDisabledBg}`,
      borderColor: `${theme.tokens.ComponentCheckboxDisabledBorder}`,
      backgroundColor: `${theme.tokens.ComponentCheckboxDisabledBg}`,
      '&.Mui-checked, &.MuiCheckbox-indeterminate': {
        color: `${theme.tokens.ComponentCheckboxDisabledColor}`
      }
    }
  }
});
export default checkBoxDefaultStyle;